import { z } from 'zod'
import { responseSchema } from '@/core/types/Response.ts'
import {
  creditPreassignedCreatedSchema,
  creditPreassignedDetailSchema
} from '@/modules/sales/clients/types/CreditPreassigned.ts'

export const creditPreassignedDetailResponseSchema = responseSchema(
  creditPreassignedDetailSchema
)

export type CreditPreassignedDetailResponse = z.infer<
  typeof creditPreassignedDetailResponseSchema
>

export const creditPreassignedCreatedResponseSchema = responseSchema(
  creditPreassignedCreatedSchema
)

export type CreditPreassignedCreatedResponse = z.infer<
  typeof creditPreassignedCreatedResponseSchema
>
